import React from 'react';
import AbstractComponent from '../AbstractComponent';
import Footer from '../layout/footer/Footer';

import { getAppDir } from '../../helper/Url';

class NaoEncontrado extends AbstractComponent {        
    href() {        
        if(!this.isLogged())            
            return getAppDir() + 'login';
        
        return getAppDir();
    }           

    render() {
        return(               
            <div id="layoutError">
                <div id="layoutError_content">
                    <main>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-6">
                                    <div className="text-center mt-4">
                                        <img className="mb-4 img-error" src={getAppDir() + "assets/img/error-404-monochrome.svg"} alt="url not found" />
                                        
                                        <p className="lead">
                                            A URL requisitada não foi encontrada neste servidor.
                                        </p>

                                        <a href={this.href()}>
                                            <i className="fas fa-arrow-left mr-1">

                                            </i>

                                            Voltar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>

                <div id="layoutError_footer">
                    <Footer />
                </div>
            </div>                           
        )
    }
}

export default NaoEncontrado;